import React from 'react'

import { Checkbox, Number as NumberInput, Select } from 'components/forms'
import loadAppConstants from 'gql/query/loadAppConstants'
import getDiscountGroupNames from 'config/localServer/query/getDiscountGroupNames'
import { notEmpty } from 'helpers/validators'

const numberProps = {
	withControls: false,
	shrink: true
}

export default (t, i18n) => [
	{
		label: t('loyalty_card_section.fields.card_limit'),
		value: 10,
		field: <NumberInput field='fields.limit' label={t('loyalty_card_section.fields.card_limit')} {...numberProps} />,
		defaultValue: 0
	}, {
		label: t('loyalty_card_section.fields.daily_limit'),
		value: 20,
		field: <NumberInput field='fields.dayLimit' label={t('loyalty_card_section.fields.daily_limit')} {...numberProps} />,
		defaultValue: 0
	}, {
		label: t('loyalty_card_section.fields.points_active'),
		value: 30,
		field: <Checkbox field='fields.isPointsActive' label={t('loyalty_card_section.fields.points_active')} />,
		defaultValue: false
	}, {
		label: t('loyalty_card_section.fields.card_type'),
		value: 40,
		field:
			<Select
				field='fields.type'
				label={t('loyalty_card_section.fields.card_type')}
				remoteOptions={{
					query: loadAppConstants,
					variables: { type: 74, language: i18n.language },
					modifyOptions: vals => vals.map(({ value, ...rest }) => ({ ...rest, value: Number(value) }))
				}}
				{...notEmpty()}
				validateOnChange
			/>
	}, {
		label: t('loyalty_card_section.fields.discount'),
		value: 50,
		field: <NumberInput
			field='fields.discount.freePercent'
			label={`${t('loyalty_card_section.fields.discount')}, %`}
			{...numberProps}
			format='percent'
			precision={2}
		/>,
		defaultValue: 0
	}, {
		label: t('loyalty_card_section.fields.discount_management'),
		value: 60,
		field: <NumberInput
			field='fields.discount.masterPercent'
			label={`${t('loyalty_card_section.fields.discount_management')}, %`}
			{...numberProps}
			format='percent'
			precision={2}
		/>,
		defaultValue: 0
	}, {
		label: t('loyalty_card_section.fields.discount_number'),
		value: 70,
		field: <Select
			field='fields.discount.numberOfPercent'
			label={t('loyalty_card_section.fields.discount_number')}
			remoteOptions={{
				query: getDiscountGroupNames,
				variables: { language: i18n.language === 'English' ? 1 : 2 },
				modifyOptions: vals => vals.map((item, i) => ({ value: i + 1, label: item })),
				additionalOptions: [{ value: 0, label: '<kein>' }]
			}}
			validate={value => !(value || value === 0) ? t('validators.required') : null}
			validateOnChange
		/>
	}, {
		label: t('loyalty_card_section.fields.loaded_discount'),
		value: 80,
		field: <Checkbox field='fields.balanceDiscount' label={t('loyalty_card_section.fields.loaded_discount')} />,
		defaultValue: false
	}, {
		label: t('loyalty_card_section.fields.discount_net_product'),
		value: 90,
		field: <Checkbox field='fields.alwaysDiscount' label={t('loyalty_card_section.fields.discount_net_product')} />,
		defaultValue: false
	}, {
		label: t('loyalty_card_section.fields.load_cash'),
		value: 100,
		field: <Checkbox field='fields.cashLoad' label={t('loyalty_card_section.fields.load_cash')} />,
		defaultValue: false
	}, {
		label: t('loyalty_card_section.fields.points_on_load'),
		value: 110,
		field: <Checkbox field='fields.balancePoints' label={t('loyalty_card_section.fields.points_on_load')} />,
		defaultValue: false
	}
]
